var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfirmDevice = function SvgConfirmDevice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.62 80v.77H68v.43a4.78 4.78 0 0 1-4.08 4.8H27.31a4.21 4.21 0 0 1-3.95-4.16v-1h.72V80l1-57.73h-.27l.21-12.1h43.84l-.21 12.1L67.62 80Z",
    fill: "#C2E2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.65 17H24.86l.21-7h43.79l-.21 7Z",
    fill: "#116DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.12 7.89c.101.362.151.735.15 1.11l-.004.189.074.001-.21 13.13-1.06 58.75-.07-.001v.131a4.78 4.78 0 0 1-4.08 4.8H27.31a4.59 4.59 0 0 1-3.931-4.263h-.069l1.288-73.07.043.001c.03-.265.09-.526.18-.778A4.5 4.5 0 0 1 29.17 5h35.7a4.35 4.35 0 0 1 4.25 2.89ZM24.34 80.02 67.09 80l1.04-57.7.197-12.3H25.575L24.34 80.02Z",
    fill: "#192C55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.79 25H30.92v30h31.87V25Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.24 65H39.13a4 4 0 1 0 0 8h13.11a4 4 0 0 0 0-8Z",
    fill: "#28BF9A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m86.11 70.74-18.33 7.33-7.53-7.15-15.59-6.3a4.31 4.31 0 0 1 5.19-4.69l5.44 1.19-10-18.41a4.45 4.45 0 0 1 3.46-6.56l6.46 10.54 13.29-.49a10 10 0 0 1 9.57 6l8.04 18.54Z",
    fill: "#FFB6AC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m86.767 68.11-20.84 10.123 1.747 3.598 20.841-10.124-1.748-3.598Z",
    fill: "#116DFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m56.154 46.525 2.677 5.415-.897.443-2.676-5.415.896-.443Zm-19.917-7.464 3.42.374-.109.994-3.42-.374.11-.994Zm1.31-5.974 3.807 2.856-.6.8-3.808-2.856.6-.8Zm16.835-1.507.853.521-1.654 2.705-.853-.522 1.654-2.704Zm-11.948-4.03 3.229 6.604-.899.439-3.229-6.603.899-.44Zm7.696.22v6.19h-1v-6.19h1Z",
    fill: "#192C55"
  })));
};
export default SvgConfirmDevice;